import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_grievances_disputes_resolved_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_grievances_disputes_resolved_line_legal_requirements',
  name: 'Are grievances and disputes resolved in line with legal requirements?',
  description:
    'Consult applicable legal requirements before answering this question. This question refers to both HOW the process of handling the grievance or dispute has been carried out and the CONTENT of the final settlement that needs to be in line with legal requirements. Settlements cannot be below the legal',
  meta: {
    slcpMeta: {
      key: 'wi-gri-8',
      number: 'WI-GRI-8',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-8', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36890,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
